import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getEnhancedBetslipSetting } from '@core/Areas/Settings/Store/selectors'
import { setEnhancedBetslipSetting } from '@core/Areas/Settings/Store'
import { SettingItemWithCheckbox } from '../Common/SettingItemWithCheckbox'

export const EnhancedBetslipSetting = () => {
  const dispatch = useDispatch()
  const isSettingEnabled = useSelector(getEnhancedBetslipSetting)

  return (
    <SettingItemWithCheckbox
      isEnabled={isSettingEnabled}
      label='Smart BetSlip'
      desciption='Automatically add runners to your BetSlip rather than quickbet. This allows you to create multis faster than ever by adding each additional selection directly to your betslip'
      onToggle={() => {
        dispatch(setEnhancedBetslipSetting(!isSettingEnabled))
      }}
    />
  )
}
